import { PathSegmentType } from "@at/design-system-patterns";
import { firstLetterToUppercase } from "@at/formatter-utils";

import { Channel } from "@at/sauron-platform-core";

import { transformPathWithSpecialCharacters } from "../transformPathWithSpecialCharacters/transform-path-with-special-characters";

interface GetBreadcrumbsDataProps {
  channel: Channel;
  derivative: string;
  vehicleMake: string;
  vehicleModel: string;
}

export const getBreadcrumbsData = ({
  channel,
  derivative,
  vehicleMake,
  vehicleModel,
}: GetBreadcrumbsDataProps): PathSegmentType[] => {
  const lowerCaseVehicleMake = vehicleMake.toLowerCase();
  const lowerCaseVehicleModel =
    transformPathWithSpecialCharacters(vehicleModel);

  return [
    {
      copy: "Home",
      link: "/",
    },
    {
      copy: firstLetterToUppercase(channel),
      link: `/${channel}`,
    },
    {
      copy: "Leasing",
      link: `/${channel}/leasing`,
    },
    {
      copy: `${vehicleMake}`,
      link:
        channel === Channel.cars
          ? `/${channel}/leasing/${lowerCaseVehicleMake}`
          : `/${channel}/leasing/search?make=${vehicleMake}`,
    },
    {
      copy: `${vehicleModel}`,
      link:
        channel === Channel.cars
          ? `/${channel}/leasing/${lowerCaseVehicleMake}/${lowerCaseVehicleModel}`
          : `/${channel}/leasing/search?make=${vehicleMake}&model=${vehicleModel}`,
    },
    {
      copy: `${derivative}`,
    },
  ];
};
